import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { compose } from "recompose";
import StockCountLine from "../../../../../../utilities/data/model/StockCountLine";
import {
  BaseRendererProps,
  StockCountItemListItemRenderer,
} from "../../../../components";

type EnhanceProps = BaseRendererProps & {
  stockCountLine: StockCountLine;
};

type EnhancedReturn = EnhanceProps &
  ExtractedObservables<ReturnType<typeof getCountObservables>>;

const getCountObservables = ({
  stockCountLine,
}: {
  stockCountLine: StockCountLine;
}) => ({
  stockCountLine: stockCountLine.observe(),
  stockCountItems: stockCountLine.items.observeWithColumns([
    "sync_state",
    "num_sync_attempts",
    "status",
  ]),
});

const enhance = compose<EnhancedReturn, EnhanceProps>(
  withObservables(["stockCountLine"], getCountObservables)
);

export const StockCountListItem = enhance(StockCountItemListItemRenderer);
